import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { IndexLinkContainer } from "react-router-bootstrap";

import "./Footer.css"; 
import Social from "../../components/Social-Icons/Social";
import { translate, getLanguage } from "../Translation/Translation";

class Footer extends Component {
  render() {
    //  // console.log(this.props);
    return (
      <div className="footer">
        <Row style={{ margin: "0px" }}>
          <Col md={12}>
            <Link to="/">
              <img src="/images/base_logo.png" alt="logo" />
            </Link>
          </Col>
        </Row>
        <Row style={{ margin: "0px" }}>
          <Col className="address" md={12} style={{ margin: "20px 0 0 0" }}>
            LIKNOSS Μεσογείων 318 Αγία Παρασκευή
            <div className="color-name" style={{ marginTop: "20px" }}>
              {" "}
              T
              <div className="address" style={{ textIndent: "10px" }}>
                {" "}
                +30 211 95.58.800
              </div>
            </div>
            <div className="color-name" style={{ marginTop: "0px" }}>
              {" "}
              F
              <div className="address" style={{ textIndent: "10px" }}>
                {" "}
                +30 211 95.59.909
              </div>
            </div>
            <div className="color-name" style={{ marginBottom: "" }}>
              {" "}
              Ε
              <div className="address" style={{ textIndent: "10px" }}>
                {" "}
                info@openseas.gr
              </div>
            </div>
          </Col>
        </Row>

        <Row style={{ paddingTop: 12, paddingBottom: 12 }}>
          <Col md={12} style={{ marginBottom: "10px" }}>
            <a target="_blank" href="http://www.liknoss.com">
              <img width="200" src="/images/logo-foot.png" alt="logo" />
            </a>
          </Col>
          <Col md={6} sm={6} xs={6} style={{ textAlign: "right" }}>
            <a
              target="_blank"
              href="https://play.google.com/store/apps/details?id=forthcrs.openseas2"
            >
              <img src="/images/en_generic_rgb_wo_45.png" alt="logo" />
            </a>
          </Col>
          <Col md={6} sm={6} xs={6} style={{ textAlign: "left" }}>
            <a
              target="_blank"
              href="https://itunes.apple.com/us/app/openseas/id1022371177?mt=8"
            >
              <img src="/images/apple-store.svg" alt="logo" />
            </a>
          </Col>
        </Row>
        <Row style={{ margin: "10px 0 0 0" }}>
          <Col className="social" md={12}>
            <Social />
          </Col>
        </Row>
        <div className="footer-links-container">
          <Link to="/terms" className="footer-link">
            {translate(getLanguage(), "Terms ofr")}
          </Link>
          <div className="slanted" />
          <Link to="/contact" className="footer-link">
            {translate(getLanguage(), "Contact Us")}
          </Link>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js